import script from "./seach.vue?vue&type=script&setup=true&lang=js"
export * from "./seach.vue?vue&type=script&setup=true&lang=js"

import "./seach.vue?vue&type=style&index=0&id=9f9cb7b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f9cb7b6"]])

export default __exports__